import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CreditCardService {
    isValid = false;
    hasError;
}
